import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Tabs = makeShortcode("Tabs");
const Tab = makeShortcode("Tab");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Kubernetes API Primitives</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Creating Pods</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Namespaces</AnchorLink>
    </AnchorLinks>
    <h1>{`Kubernetes API Primitives`}</h1>
    <p>{`Kubernetes API primitive, also known as Kubernetes objects, are the basic building blocks of any application running in Kubernetes`}</p>
    <p>{`Examples:`}</p>
    <ul>
      <li parentName="ul">{`Pod`}</li>
      <li parentName="ul">{`Node`}</li>
      <li parentName="ul">{`Service`}</li>
      <li parentName="ul">{`ServiceAccount`}</li>
    </ul>
    <p>{`Two primary members`}</p>
    <ul>
      <li parentName="ul">{`Spec, desired state`}</li>
      <li parentName="ul">{`Status, current state`}</li>
    </ul>
    <h2>{`Resources`}</h2>
    <p><strong parentName="p">{`OpenShift`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.openshift.com/container-platform/4.3/nodes/pods/nodes-pods-using.html"
        }}>{`Pods`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.openshift.com/container-platform/4.3/nodes/nodes/nodes-nodes-viewing.html"
        }}>{`Nodes`}</a></li>
    </ul>
    <p><strong parentName="p">{`IKS`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kubernetes.io/docs/concepts/overview/working-with-objects/kubernetes-objects/"
        }}>{`Objects`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kubernetes.io/docs/tutorials/kubernetes-basics/"
        }}>{`Kube Basics`}</a></li>
    </ul>
    <h2>{`References`}</h2>
    <Tabs mdxType="Tabs">
      <Tab label="OpenShift" mdxType="Tab">
        <p><strong parentName="p">{`Prints all API Resources`}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc api-resources
`}</code></pre>
        <p><strong parentName="p">{`Prints all API Resources with their verbs.`}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc api-resources -o wide
`}</code></pre>
        <p><strong parentName="p">{`Prints all API Resources names only`}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc api-resources -o name
`}</code></pre>
        <p>{`  `}<strong parentName="p">{`Prints each of the available nodes, projects, services, deployments, and pods `}</strong>{` `}</p>
        <pre><code parentName="pre" {...{}}>{`oc get nodes,ns,po,deploy,svc
`}</code></pre>
        <p><strong parentName="p">{`Prints the node’s description`}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc describe node 
`}</code></pre>
      </Tab>
      <Tab label="IKS" mdxType="Tab">
        <p><strong parentName="p">{` Getting API Resources `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`kubectl api-resources
`}</code></pre>
        <p><strong parentName="p">{` Viewing Resources `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`kubectl api-resources -o wide
`}</code></pre>
        <p><strong parentName="p">{` Viewing Resources `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`kubectl api-resources -o name
`}</code></pre>
        <p><strong parentName="p">{` Getting a list of specific objects `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`kubectl get nodes,ns,po,deploy,svc
`}</code></pre>
        <p><strong parentName="p">{` Describing the resources `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`kubectl describe node --all
`}</code></pre>
      </Tab>
    </Tabs>
    <h1>{`Creating Pods`}</h1>
    <p>{`A Pod is the basic execution unit of a Kubernetes application–the smallest and simplest unit in the Kubernetes object model that you create or deploy. A Pod represents processes running on your Cluster.`}</p>
    <p>{`A Pod encapsulates an application’s container (or, in some cases, multiple containers), storage resources, a unique network IP, and options that govern how the container(s) should run. A Pod represents a unit of deployment: a single instance of an application in Kubernetes, which might consist of either a single container or a small number of containers that are tightly coupled and that share resources.`}</p>
    <h2>{`Resources`}</h2>
    <p><strong parentName="p">{`OpenShift`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.openshift.com/container-platform/4.3/nodes/pods/nodes-pods-using.html"
        }}>{`About Pods`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.openshift.com/container-platform/4.3/nodes/pods/nodes-pods-configuring.html"
        }}>{`Cluster Configuration for Pods`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.openshift.com/container-platform/4.3/nodes/pods/nodes-pods-autoscaling.html"
        }}>{`Pod Autoscaling`}</a></li>
    </ul>
    <p><strong parentName="p">{`IKS`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kubernetes.io/docs/concepts/workloads/pods/pod-overview/"
        }}>{`Pod Overview`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kubernetes.io/docs/concepts/workloads/pods/pod-lifecycle/"
        }}>{`Pod Lifecycle`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kubernetes.io/docs/concepts/workloads/pods/pod/"
        }}>{`Pod Usage`}</a></li>
    </ul>
    <h2>{`References`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`apiVersion: v1
kind: Pod
metadata:
  name: myapp-pod
  labels:
    app: myapp
spec:
  containers:
  - name: myapp-container
    image: busybox
    command: ['sh', '-c', 'echo Hello Kubernetes! && sleep 3600']
`}</code></pre>
    <Tabs mdxType="Tabs">
      <Tab label="OpenShift" mdxType="Tab">
        <p><strong parentName="p">{` Get Current Pods in Project `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc get pods
`}</code></pre>
        <p><strong parentName="p">{` Get Pod’s Description `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc describe pod <pod-name>
`}</code></pre>
        <p><strong parentName="p">{` Get Pods with their IP and node location `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc get pods -o wide
`}</code></pre>
        <p><strong parentName="p">{` Get Pods Stats `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc adm top pods
`}</code></pre>
      </Tab>
      <Tab label="IKS" mdxType="Tab">
        <p><strong parentName="p">{` Get Current Pods in Project `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`kubectl get pods
`}</code></pre>
        <p><strong parentName="p">{` Get Pod’s Description `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`kubectl describe pod <pod-name>
`}</code></pre>
        <p><strong parentName="p">{` Delete a Pod `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`kubectl delete pod <pod-name>
`}</code></pre>
        <p><strong parentName="p">{` Edit a Pod `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`kubectl edit pod <pod-name>
`}</code></pre>
      </Tab>
    </Tabs>
    <h1>{`Projects/Namespaces`}</h1>
    <p>{`Namespaces are intended for use in environments with many users spread across multiple teams, or projects.`}</p>
    <p>{`Namespaces provide a scope for names. Names of resources need to be unique within a namespace, but not across namespaces.`}</p>
    <p>{`Namespaces are a way to divide cluster resources between multiple users (via resource quota).`}</p>
    <p>{`It is not necessary to use multiple namespaces just to separate slightly different resources, such as different versions of the same software: use labels to distinguish resources within the same namespace. In practice namespaces are used to deploy different versions based on stages of the CICD pipeline (dev, test, stage, prod)`}</p>
    <h2>{`Resources`}</h2>
    <p><strong parentName="p">{`OpenShift`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.openshift.com/container-platform/4.3/applications/projects/working-with-projects.html"
        }}>{`Working With Projects`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.openshift.com/container-platform/4.3/cli_reference/openshift_cli/getting-started-cli.html#creating-a-project"
        }}>{`Creating Projects`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.openshift.com/container-platform/4.3/applications/projects/configuring-project-creation.html"
        }}>{`Configure Project Creation`}</a></li>
    </ul>
    <p><strong parentName="p">{`IKS`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kubernetes.io/docs/concepts/overview/working-with-objects/namespaces/"
        }}>{`Namespaces`}</a></li>
    </ul>
    <h2>{`References:`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`apiVersion: v1
kind: Namespace
metadata:
  name: foo
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`apiVersion: v1
kind: Pod
metadata:
  name: myapp-pod
  namespace: bar
  labels:
    app: myapp
spec:
  containers:
  - name: myapp-container
    image: busybox
    command: ['sh', '-c', 'echo Hello Kubernetes! && sleep 3600']
`}</code></pre>
    <Tabs mdxType="Tabs">
      <Tab label="OpenShift" mdxType="Tab">
        <p><strong parentName="p">{`Create a new Project`}</strong>{` `}</p>
        <pre><code parentName="pre" {...{}}>{`oc new-project my-project
`}</code></pre>
        <p><strong parentName="p">{`Viewing Current Project`}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc project
`}</code></pre>
        <p><strong parentName="p">{`Viewing Project Status`}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc status
`}</code></pre>
      </Tab>
      <Tab label="IKS" mdxType="Tab">
        <p><strong parentName="p">{`Getting all namespaces in cluster`}</strong>{` `}</p>
        <pre><code parentName="pre" {...{}}>{`kubectl get namespaces
`}</code></pre>
        <p><strong parentName="p">{`Create a new namespace called bar`}</strong></p>
        <pre><code parentName="pre" {...{}}>{`kubectl create ns bar
`}</code></pre>
        <p><strong parentName="p">{`Setting Namespace in Context`}</strong></p>
        <pre><code parentName="pre" {...{}}>{`kubectl set-context --current --namespace=bar
`}</code></pre>
      </Tab>
    </Tabs>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      